import React from 'react';
import { Table, TableContainer, Paper } from '@material-ui/core';

import { TableRows } from './TableRows';
import { TableProps } from './interfaces';
import { TableHeader } from './TableHeader';

export const GenericTable = <T, K extends keyof T>({ data, columns, maxHeight }: TableProps<T, K>) => {
  return (
    <Paper>
      <TableContainer style={{ maxHeight: maxHeight, overflowY: 'auto' }}>
        <Table>
          <TableHeader columns={columns} />
          <TableRows data={data} columns={columns} />
        </Table>
      </TableContainer>
    </Paper>
  );
};
